const inquiriesWithAssessmentsTransformer = data => {
  return data?.map((item, index) => {
    return { label: item?.inquiryId, value: item?.inquiryId }
  })
}

export default inquiriesWithAssessmentsTransformer
